import React from 'react';
import Typography from 'fuse-ui/components/Typography';

const UnverifiedSenderDetailsContent = () => {
    return (
        <>
            <Typography variant="subtitle1">We think this sender is legitimate</Typography>
            <Typography color="textSecondary">Here's why</Typography>
        </>
    );
};

export default UnverifiedSenderDetailsContent;
